import { render, staticRenderFns } from "./RealFriendMeetingCard.vue?vue&type=template&id=4a9a8d25&scoped=true"
import script from "./RealFriendMeetingCard.vue?vue&type=script&lang=js"
export * from "./RealFriendMeetingCard.vue?vue&type=script&lang=js"
import style0 from "./RealFriendMeetingCard.vue?vue&type=style&index=0&id=4a9a8d25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a8d25",
  null
  
)

export default component.exports